import { Box, Button, CircularProgress, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdCreate, MdInfoOutline, MdOutlineTroubleshoot } from 'react-icons/md';
import UnidadeSelect from './UnidadeSelect';
import PeriodoSelect from './PeriodoSelect';

export default class BuscaInventario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            unidade: null,
            unidadeErr: false,
            periodo: null,
            periodoErr: false
        }
    }

    onSearch = () => {
        let { unidade, periodo } = this.state;

        if (!unidade) {
            this.setState({ unidadeErr: true });
            return;
        }

        if (!periodo) {
            this.setState({ periodoErr: true });
            return;
        }

        if (this.props.onSearch) {
            this.props.onSearch({ ...periodo, unidade });
        }
    }

    onReset = () => {
        this.setState({ unidade: null, periodo: null })
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    render() {
        let { unidade, periodo, unidadeErr, periodoErr } = this.state;
        let { loading } = this.props;
        return (
            <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" justifyItems="center" gap={1} p={1.2}>
                    <MdOutlineTroubleshoot />
                    <Typography variant="caption"><b>BUSCAR PERÍODO DE INVENTÁRIO</b></Typography>
                </Stack>
                <Stack p={2} direction="row" gap={1}>
                    <UnidadeSelect disabled={loading} sx={{ flex: 1 }} value={unidade} onChange={(unidade) => this.setState({ unidade, unidadeErr: false })} error={unidadeErr} />
                    <PeriodoSelect disabled={loading} unidadeId={unidade?.id} sx={{ flex: 1 }} value={periodo} onChange={(periodo) => this.setState({ periodo, periodoErr: false })} error={periodoErr} />
                    <Box mt={0.5}>{loading ? <CircularProgress sx={{ ml: 0.5 }} size={30} /> : <Button type="submit" onClick={this.onSearch} size="small" color="btnStyle" variant="contained" disableElevation>Buscar</Button>}</Box>
                    {!loading && <Box mt={0.5}><Button type="submit" onClick={this.onReset} size="small" color="btnStyle" variant="contained" disableElevation>Limpar</Button></Box>}
                </Stack>
            </Stack>
        );
    }
}